import './Hero.scss';
import bgAi from '../../images/bg/bg_ai.jpg';
// import bgAi from '../../images/bg/bg_ai_02.jpg';

const Hero = () => {
  return (
    <section className="hero" style={{ backgroundImage: `url(${bgAi})` }}>
      <div className="container">
        <div className="content">
          <p className="patent-badge">
            원천기술 3건 특허 출원
          </p>
          <h1 className="title">
            <span className="highlight">PDF(수식)</span>를 <span className="highlight">HWP</span>로 변환하는<br />
            AI 솔루션
          </h1>
          <p className="subtitle">수학 문제 처리를 위한 최고의 도구</p>
        </div>
      </div>
      <div className="patent-notice">
        <span className="notice-label">특허 출원 안내</span>
        <span className="notice-text">
          AI 기반 수학 문제 자동 변환 &middot; 변형 &middot; 도형 재구성 원천기술 <strong>3건 특허 출원</strong> (출원번호: 10-2026-0045117 외 2건)
        </span>
      </div>
    </section>
  );
};

export default Hero;